export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryLabel: string;
  imageUrl: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const categories: { id: string; label: string; icon: string }[] = [
  { id: 'entertainment', label: '影音娱乐', icon: 'ri-movie-2-line' },
  { id: 'shopping', label: '在线购物', icon: 'ri-shopping-bag-3-line' },
  { id: 'news', label: '亚洲资讯', icon: 'ri-newspaper-line' },
  { id: 'lifestyle', label: '数字生活', icon: 'ri-smartphone-line' },
  { id: 'tech', label: '科技前沿', icon: 'ri-cpu-line' },
  { id: 'travel', label: '旅游出行', icon: 'ri-flight-takeoff-line' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2026年亚洲流媒体市场格局：本土平台崛起，全球巨头加速布局',
    excerpt: '随着亚洲各国本土流媒体平台迅速崛起，Netflix、Disney+等全球巨头也在加速本地化策略。深入分析当前亚洲流媒体市场最新动态。',
    content: '<p>2026年，亚洲流媒体市场正经历前所未有的变革。中国、韩国、日本、印度等国家的本土平台凭借对本地用户需求的深刻理解和丰富的本地内容库，正在重塑整个行业格局。</p><p>据最新数据显示，亚洲流媒体市场规模已突破800亿美元，年增长率保持在15%以上。</p><h2>本土内容成为核心竞争力</h2><p>在亚洲市场，本土原创内容已成为各大平台争夺用户的关键武器。韩国出品的剧集全球热播，日本动画持续输出高质量作品，中国古装剧和现实题材剧集也在海外收获大量粉丝。</p><h2>技术创新推动体验升级</h2><p>AI推荐算法、4K/8K超高清画质、沉浸式音效等技术正在成为标配。未来三年，随着5G网络在亚洲的全面普及，移动端流媒体消费预计将占据总市场的65%以上。</p>',
    category: 'entertainment',
    categoryLabel: '影音娱乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Asian%20streaming%20platform%20interface%20with%20vibrant%20movie%20posters%20on%20dark%20minimalist%20background%2C%20futuristic%20UI%20design%20with%20warm%20coral%20and%20gold%20accents%2C%20cinematic%20atmosphere&width=800&height=450&seq=article-streaming-2026&orientation=landscape',
    author: '张明远',
    date: '2026-08-08',
    readTime: '8分钟',
    tags: ['流媒体', '亚洲市场', 'Netflix', '爱奇艺'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '东南亚电商爆发式增长：Shopee与Lazada双雄争霸新格局',
    excerpt: '东南亚电商市场在2026年迎来新一轮爆发，Shopee和Lazada在物流、支付和社交电商领域展开激烈竞争。',
    content: '<p>东南亚电商市场在2026年继续保持着惊人的增长速度。据e-Conomy SEA报告，该地区电商GMV已突破2000亿美元，印度尼西亚、泰国和越南成为增长最快的三个市场。</p><h2>社交电商成为新战场</h2><p>TikTok Shop的快速崛起彻底改变了东南亚电商格局。直播带货、短视频种草等模式深受年轻消费者喜爱。</p><h2>物流基础设施竞赛</h2><p>各大平台在物流领域的投入持续加大。Shopee自建物流网络已覆盖东南亚主要城市，Lazada与菜鸟网络深度合作，将跨境配送时效压缩至3-5天。</p>',
    category: 'shopping',
    categoryLabel: '在线购物',
    imageUrl: 'https://readdy.ai/api/search-image?query=Southeast%20Asian%20ecommerce%20warehouse%20with%20packages%20and%20logistics%20workers%2C%20modern%20bright%20industrial%20space%20with%20warm%20lighting%2C%20clean%20organized%20shelves&width=800&height=450&seq=article-ecommerce-2026&orientation=landscape',
    author: '李婷',
    date: '2026-08-06',
    readTime: '6分钟',
    tags: ['电商', '东南亚', 'Shopee', 'Lazada'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '中日韩AI竞赛白热化：从大模型到产业落地的全面比拼',
    excerpt: '中国、日本、韩国在人工智能领域的竞争日趋激烈，三国各自在AI领域展现出不同优势，亚洲正成为全球AI创新的重要引擎。',
    content: '<p>2026年，中日韩三国在AI领域的竞争已经进入白热化阶段。中国在大模型数量和参数规模上保持领先，日本在机器人AI和精密制造AI方面独具特色，韩国在AI芯片和消费电子AI应用上表现突出。</p><h2>中国：大模型生态繁荣</h2><p>百度文心、阿里通义、字节豆包等国产大模型持续迭代，在中文理解和多模态能力上已达到国际领先水平。</p><h2>日本：深耕垂直场景</h2><p>日本企业将AI技术与制造业、医疗健康、养老服务深度融合，在工业机器人和辅助诊断等领域的AI应用处于世界前列。</p>',
    category: 'tech',
    categoryLabel: '科技前沿',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20holographic%20Asian%20characters%20and%20circuit%20patterns%2C%20warm%20coral%20and%20gold%20neon%20accents%20on%20dark%20background%2C%20clean%20minimalist%20tech%20aesthetic&width=800&height=450&seq=article-ai-asia&orientation=landscape',
    author: '王浩然',
    date: '2026-08-04',
    readTime: '10分钟',
    tags: ['AI', '人工智能', '中国AI', '日本科技'],
    featured: true,
  },
  {
    id: 'article-4',
    title: '亚洲数字支付革命：从扫码到刷掌，无感支付时代来临',
    excerpt: '从微信支付、支付宝到印度UPI，再到日本PayPay和韩国KakaoPay，亚洲数字支付正在引领全球支付方式的变革。',
    content: '<p>亚洲已成为全球数字支付创新的前沿阵地。从扫码支付到NFC近场支付，再到最新的生物识别支付，亚洲消费者正在享受前所未有的便捷支付体验。</p><h2>中国：无现金社会领跑者</h2><p>微信支付和支付宝已经渗透到中国人日常生活的方方面面，扫码支付覆盖率超过95%。刷脸支付和掌纹支付等新技术也在加速落地。</p><h2>印度UPI典范</h2><p>印度统一支付接口(UPI)已成为全球最成功的数字支付基础设施之一，月交易量超过100亿笔。</p>',
    category: 'lifestyle',
    categoryLabel: '数字生活',
    imageUrl: 'https://readdy.ai/api/search-image?query=Asian%20digital%20payment%20scene%20with%20smartphone%20showing%20QR%20code%20payment%20interface%2C%20warm%20modern%20cafe%20background%2C%20clean%20minimalist%20composition%2C%20soft%20natural%20lighting&width=800&height=450&seq=article-digital-payment&orientation=landscape',
    author: '陈思雨',
    date: '2026-08-02',
    readTime: '7分钟',
    tags: ['数字支付', '微信支付', '支付宝', 'UPI'],
    featured: false,
  },
  {
    id: 'article-5',
    title: '日本动漫产业2026：全球化IP运营与AI创作工具的碰撞',
    excerpt: '日本动漫产业在全球化扩张中迎来新挑战。AI辅助创作工具的普及正在改变传统制作流程。',
    content: '<p>日本动漫产业在2026年继续保持着强劲的增长势头。海外市场规模首次超过日本本土，达到2.5万亿日元。</p><h2>AI改变创作流程</h2><p>AI辅助绘画工具正在被越来越多的动画工作室采用，显著提高了中间帧制作效率。但业界对AI在创意核心环节的应用仍持谨慎态度。</p><h2>中国市场的特殊地位</h2><p>中国市场已成为日本动漫最大的海外市场，在制作外包和联合制作方面的合作不断深化。</p>',
    category: 'entertainment',
    categoryLabel: '影音娱乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20studio%20workspace%20with%20digital%20drawing%20tablets%20and%20colorful%20character%20illustrations%2C%20creative%20atmosphere%20with%20warm%20lighting%2C%20modern%20clean%20environment&width=800&height=450&seq=article-anime-2026&orientation=landscape',
    author: '刘子涵',
    date: '2026-07-30',
    readTime: '6分钟',
    tags: ['日本动漫', '动画产业', 'AI创作', '全球化'],
    featured: false,
  },
  {
    id: 'article-6',
    title: '亚洲可持续旅游新趋势：绿色出行与深度文化体验',
    excerpt: '后疫情时代，亚洲旅游业正在向可持续方向发展。从巴厘岛的生态度假村到京都的文化遗产保护，游客越来越追求有意义的旅行体验。',
    content: '<p>2026年的亚洲旅游业呈现出全新的面貌。可持续旅游已从一个小众概念演变为主流趋势，越来越多的旅行者关注旅行的环境和社会影响。</p><h2>生态度假村的崛起</h2><p>在巴厘岛、普吉岛和马尔代夫等热门目的地，生态友好型度假村正在取代传统的大型酒店，采用可再生能源和零废弃运营模式。</p><h2>文化沉浸体验</h2><p>深度文化体验成为亚洲旅游的新亮点。从京都的茶道体验到清迈的泰拳训练营，游客渴望真正融入当地文化。</p>',
    category: 'travel',
    categoryLabel: '旅游出行',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sustainable%20eco%20resort%20in%20Bali%20with%20bamboo%20architecture%20and%20tropical%20greenery%2C%20natural%20warm%20lighting%2C%20peaceful%20atmosphere%2C%20clean%20modern%20design&width=800&height=450&seq=article-eco-travel&orientation=landscape',
    author: '赵雨晴',
    date: '2026-07-28',
    readTime: '5分钟',
    tags: ['可持续旅游', '生态度假', '文化体验', '亚洲旅行'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '韩国美妆科技革命：AI皮肤诊断与个性化定制美妆',
    excerpt: '韩国美妆行业正在经历一场科技革命。AR虚拟试妆、AI皮肤分析、3D打印定制彩妆等创新技术正在重塑消费者的美妆体验。',
    content: '<p>韩国美妆产业在2026年迎来了科技与美丽的深度融合。K-Beauty正在将AI、AR和3D打印等前沿技术融入产品研发和消费体验。</p><h2>AI皮肤诊断系统</h2><p>爱茉莉太平洋和LG生活健康等韩国美妆巨头推出基于AI的皮肤诊断系统，通过手机摄像头精准分析用户皮肤状况并提供个性化护肤方案。</p><h2>定制化趋势</h2><p>从粉底色号到口红颜色，消费者可根据自己的肤色和偏好在线上定制独一无二的美妆产品。</p>',
    category: 'shopping',
    categoryLabel: '在线购物',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20beauty%20tech%20lab%20with%20futuristic%20skincare%20devices%20and%20holographic%20displays%2C%20clean%20white%20minimalist%20interior%20with%20rose%20gold%20accents%2C%20professional%20atmosphere&width=800&height=450&seq=article-kbeauty-tech&orientation=landscape',
    author: '韩美琳',
    date: '2026-07-26',
    readTime: '5分钟',
    tags: ['韩国美妆', 'AI美容', '定制化', 'K-Beauty'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '印度科技创业生态2026：从外包中心到全球创新引擎',
    excerpt: '印度科技创业生态正在经历质的飞跃。从SaaS到太空科技，印度初创企业正在全球市场崭露头角。',
    content: '<p>2026年，印度科技创业生态已完成从外包中心到创新引擎的转型。班加罗尔、德里NCR和海德拉巴聚集了超过5万家科技初创企业。</p><h2>SaaS领域全球竞争力</h2><p>Zoho、Freshworks等印度SaaS企业的成功为后来者树立了榜样。印度SaaS市场规模突破500亿美元。</p><h2>太空科技新势力</h2><p>以Skyroot Aerospace为代表的印度太空科技初创企业，正以极低成本提供卫星发射服务。</p>',
    category: 'tech',
    categoryLabel: '科技前沿',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Indian%20tech%20startup%20office%20in%20Bangalore%20with%20diverse%20team%20collaborating%2C%20bright%20open%20workspace%20with%20greenery%2C%20warm%20natural%20lighting&width=800&height=450&seq=article-india-tech&orientation=landscape',
    author: '阿米特·夏尔马',
    date: '2026-07-24',
    readTime: '7分钟',
    tags: ['印度科技', '创业生态', 'SaaS', '太空科技'],
    featured: false,
  },
];